export const DEV_BAR_HEIGHT = "2rem";
export const MOBILE_DEV_BAR_HEIGHT = "2.75rem";
export const MOBILE_IMPERSONATION_BAR_HEIGHT = "6.25rem";

export const FRAME_WIDTH = "0.25rem";
